/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as hiddenFolderLayoutsSideDrawerLayoutRouteImport } from './routes/(hidden-folder)/_layouts/_sideDrawerLayout'

const Forgot_passwordLazyRouteImport = createFileRoute('/forgot_password')()
const Change_passwordLazyRouteImport = createFileRoute('/change_password')()
const IndexLazyRouteImport = createFileRoute('/')()
const hiddenFolderLayoutsRouteImport = createFileRoute(
  '/(hidden-folder)/_layouts',
)()
const hiddenFolderLayoutsSideDrawerLayoutUsersLazyRouteImport = createFileRoute(
  '/(hidden-folder)/_layouts/_sideDrawerLayout/users',
)()
const hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRouteImport =
  createFileRoute('/(hidden-folder)/_layouts/_sideDrawerLayout/tutorial_faq')()
const hiddenFolderLayoutsSideDrawerLayoutTicketLazyRouteImport =
  createFileRoute('/(hidden-folder)/_layouts/_sideDrawerLayout/ticket')()
const hiddenFolderLayoutsSideDrawerLayoutStatsLazyRouteImport = createFileRoute(
  '/(hidden-folder)/_layouts/_sideDrawerLayout/stats',
)()
const hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRouteImport =
  createFileRoute('/(hidden-folder)/_layouts/_sideDrawerLayout/reviews')()
const hiddenFolderLayoutsSideDrawerLayoutPostsLazyRouteImport = createFileRoute(
  '/(hidden-folder)/_layouts/_sideDrawerLayout/posts',
)()
const hiddenFolderLayoutsSideDrawerLayoutPosLazyRouteImport = createFileRoute(
  '/(hidden-folder)/_layouts/_sideDrawerLayout/pos',
)()
const hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRouteImport =
  createFileRoute(
    '/(hidden-folder)/_layouts/_sideDrawerLayout/instagram_connector',
  )()
const hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRouteImport =
  createFileRoute('/(hidden-folder)/_layouts/_sideDrawerLayout/ig_connector')()
const hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRouteImport =
  createFileRoute('/(hidden-folder)/_layouts/_sideDrawerLayout/groups')()
const hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRouteImport =
  createFileRoute('/(hidden-folder)/_layouts/_sideDrawerLayout/google_sync')()
const hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRouteImport =
  createFileRoute(
    '/(hidden-folder)/_layouts/_sideDrawerLayout/google_connector',
  )()
const hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRouteImport =
  createFileRoute(
    '/(hidden-folder)/_layouts/_sideDrawerLayout/google-my-business',
  )()
const hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRouteImport =
  createFileRoute(
    '/(hidden-folder)/_layouts/_sideDrawerLayout/google-callback',
  )()
const hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRouteImport =
  createFileRoute(
    '/(hidden-folder)/_layouts/_sideDrawerLayout/form_unification',
  )()
const hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRouteImport =
  createFileRoute('/(hidden-folder)/_layouts/_sideDrawerLayout/form_subentro')()
const hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRouteImport =
  createFileRoute(
    '/(hidden-folder)/_layouts/_sideDrawerLayout/facebook_connector',
  )()
const hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRouteImport =
  createFileRoute('/(hidden-folder)/_layouts/_sideDrawerLayout/adv_admin')()
const hiddenFolderLayoutsSideDrawerLayoutAdvLazyRouteImport = createFileRoute(
  '/(hidden-folder)/_layouts/_sideDrawerLayout/adv',
)()
const hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRouteImport =
  createFileRoute(
    '/(hidden-folder)/_layouts/_sideDrawerLayout/client_profile/$id/',
  )()

const Forgot_passwordLazyRoute = Forgot_passwordLazyRouteImport.update({
  id: '/forgot_password',
  path: '/forgot_password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/forgot_password.lazy').then((d) => d.Route),
)
const Change_passwordLazyRoute = Change_passwordLazyRouteImport.update({
  id: '/change_password',
  path: '/change_password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/change_password.lazy').then((d) => d.Route),
)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const hiddenFolderLayoutsRoute = hiddenFolderLayoutsRouteImport.update({
  id: '/(hidden-folder)/_layouts',
  getParentRoute: () => rootRouteImport,
} as any)
const hiddenFolderLayoutsSideDrawerLayoutRoute =
  hiddenFolderLayoutsSideDrawerLayoutRouteImport.update({
    id: '/_sideDrawerLayout',
    getParentRoute: () => hiddenFolderLayoutsRoute,
  } as any)
const hiddenFolderLayoutsSideDrawerLayoutUsersLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutUsersLazyRouteImport
    .update({
      id: '/users',
      path: '/users',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/users.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRouteImport
    .update({
      id: '/tutorial_faq',
      path: '/tutorial_faq',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/tutorial_faq.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutTicketLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutTicketLazyRouteImport
    .update({
      id: '/ticket',
      path: '/ticket',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/ticket.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutStatsLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutStatsLazyRouteImport
    .update({
      id: '/stats',
      path: '/stats',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/stats.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRouteImport
    .update({
      id: '/reviews',
      path: '/reviews',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/reviews.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutPostsLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutPostsLazyRouteImport
    .update({
      id: '/posts',
      path: '/posts',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/posts.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutPosLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutPosLazyRouteImport
    .update({
      id: '/pos',
      path: '/pos',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/pos.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRouteImport
    .update({
      id: '/instagram_connector',
      path: '/instagram_connector',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/instagram_connector.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRouteImport
    .update({
      id: '/ig_connector',
      path: '/ig_connector',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/ig_connector.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRouteImport
    .update({
      id: '/groups',
      path: '/groups',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/groups.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRouteImport
    .update({
      id: '/google_sync',
      path: '/google_sync',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/google_sync.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRouteImport
    .update({
      id: '/google_connector',
      path: '/google_connector',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/google_connector.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRouteImport
    .update({
      id: '/google-my-business',
      path: '/google-my-business',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/google-my-business.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRouteImport
    .update({
      id: '/google-callback',
      path: '/google-callback',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/google-callback.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRouteImport
    .update({
      id: '/form_unification',
      path: '/form_unification',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/form_unification.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRouteImport
    .update({
      id: '/form_subentro',
      path: '/form_subentro',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/form_subentro.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRouteImport
    .update({
      id: '/facebook_connector',
      path: '/facebook_connector',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/facebook_connector.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRouteImport
    .update({
      id: '/adv_admin',
      path: '/adv_admin',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/adv_admin.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutAdvLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutAdvLazyRouteImport
    .update({
      id: '/adv',
      path: '/adv',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/adv.lazy'
      ).then((d) => d.Route),
    )
const hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRoute =
  hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRouteImport
    .update({
      id: '/client_profile/$id/',
      path: '/client_profile/$id/',
      getParentRoute: () => hiddenFolderLayoutsSideDrawerLayoutRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(hidden-folder)/_layouts/_sideDrawerLayout/client_profile/$id/index.lazy'
      ).then((d) => d.Route),
    )

export interface FileRoutesByFullPath {
  '/': typeof hiddenFolderLayoutsSideDrawerLayoutRouteWithChildren
  '/change_password': typeof Change_passwordLazyRoute
  '/forgot_password': typeof Forgot_passwordLazyRoute
  '/adv': typeof hiddenFolderLayoutsSideDrawerLayoutAdvLazyRoute
  '/adv_admin': typeof hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRoute
  '/facebook_connector': typeof hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRoute
  '/form_subentro': typeof hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRoute
  '/form_unification': typeof hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRoute
  '/google-callback': typeof hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRoute
  '/google-my-business': typeof hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRoute
  '/google_connector': typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRoute
  '/google_sync': typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRoute
  '/groups': typeof hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRoute
  '/ig_connector': typeof hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRoute
  '/instagram_connector': typeof hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRoute
  '/pos': typeof hiddenFolderLayoutsSideDrawerLayoutPosLazyRoute
  '/posts': typeof hiddenFolderLayoutsSideDrawerLayoutPostsLazyRoute
  '/reviews': typeof hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRoute
  '/stats': typeof hiddenFolderLayoutsSideDrawerLayoutStatsLazyRoute
  '/ticket': typeof hiddenFolderLayoutsSideDrawerLayoutTicketLazyRoute
  '/tutorial_faq': typeof hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRoute
  '/users': typeof hiddenFolderLayoutsSideDrawerLayoutUsersLazyRoute
  '/client_profile/$id': typeof hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof hiddenFolderLayoutsSideDrawerLayoutRouteWithChildren
  '/change_password': typeof Change_passwordLazyRoute
  '/forgot_password': typeof Forgot_passwordLazyRoute
  '/adv': typeof hiddenFolderLayoutsSideDrawerLayoutAdvLazyRoute
  '/adv_admin': typeof hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRoute
  '/facebook_connector': typeof hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRoute
  '/form_subentro': typeof hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRoute
  '/form_unification': typeof hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRoute
  '/google-callback': typeof hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRoute
  '/google-my-business': typeof hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRoute
  '/google_connector': typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRoute
  '/google_sync': typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRoute
  '/groups': typeof hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRoute
  '/ig_connector': typeof hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRoute
  '/instagram_connector': typeof hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRoute
  '/pos': typeof hiddenFolderLayoutsSideDrawerLayoutPosLazyRoute
  '/posts': typeof hiddenFolderLayoutsSideDrawerLayoutPostsLazyRoute
  '/reviews': typeof hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRoute
  '/stats': typeof hiddenFolderLayoutsSideDrawerLayoutStatsLazyRoute
  '/ticket': typeof hiddenFolderLayoutsSideDrawerLayoutTicketLazyRoute
  '/tutorial_faq': typeof hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRoute
  '/users': typeof hiddenFolderLayoutsSideDrawerLayoutUsersLazyRoute
  '/client_profile/$id': typeof hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/change_password': typeof Change_passwordLazyRoute
  '/forgot_password': typeof Forgot_passwordLazyRoute
  '/(hidden-folder)/_layouts': typeof hiddenFolderLayoutsRouteWithChildren
  '/(hidden-folder)/_layouts/_sideDrawerLayout': typeof hiddenFolderLayoutsSideDrawerLayoutRouteWithChildren
  '/(hidden-folder)/_layouts/_sideDrawerLayout/adv': typeof hiddenFolderLayoutsSideDrawerLayoutAdvLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/adv_admin': typeof hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/facebook_connector': typeof hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/form_subentro': typeof hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/form_unification': typeof hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/google-callback': typeof hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/google-my-business': typeof hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/google_connector': typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/google_sync': typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/groups': typeof hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/ig_connector': typeof hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/instagram_connector': typeof hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/pos': typeof hiddenFolderLayoutsSideDrawerLayoutPosLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/posts': typeof hiddenFolderLayoutsSideDrawerLayoutPostsLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/reviews': typeof hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/stats': typeof hiddenFolderLayoutsSideDrawerLayoutStatsLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/ticket': typeof hiddenFolderLayoutsSideDrawerLayoutTicketLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/tutorial_faq': typeof hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/users': typeof hiddenFolderLayoutsSideDrawerLayoutUsersLazyRoute
  '/(hidden-folder)/_layouts/_sideDrawerLayout/client_profile/$id/': typeof hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change_password'
    | '/forgot_password'
    | '/adv'
    | '/adv_admin'
    | '/facebook_connector'
    | '/form_subentro'
    | '/form_unification'
    | '/google-callback'
    | '/google-my-business'
    | '/google_connector'
    | '/google_sync'
    | '/groups'
    | '/ig_connector'
    | '/instagram_connector'
    | '/pos'
    | '/posts'
    | '/reviews'
    | '/stats'
    | '/ticket'
    | '/tutorial_faq'
    | '/users'
    | '/client_profile/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/change_password'
    | '/forgot_password'
    | '/adv'
    | '/adv_admin'
    | '/facebook_connector'
    | '/form_subentro'
    | '/form_unification'
    | '/google-callback'
    | '/google-my-business'
    | '/google_connector'
    | '/google_sync'
    | '/groups'
    | '/ig_connector'
    | '/instagram_connector'
    | '/pos'
    | '/posts'
    | '/reviews'
    | '/stats'
    | '/ticket'
    | '/tutorial_faq'
    | '/users'
    | '/client_profile/$id'
  id:
    | '__root__'
    | '/'
    | '/change_password'
    | '/forgot_password'
    | '/(hidden-folder)/_layouts'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/adv'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/adv_admin'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/facebook_connector'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/form_subentro'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/form_unification'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/google-callback'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/google-my-business'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/google_connector'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/google_sync'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/groups'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/ig_connector'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/instagram_connector'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/pos'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/posts'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/reviews'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/stats'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/ticket'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/tutorial_faq'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/users'
    | '/(hidden-folder)/_layouts/_sideDrawerLayout/client_profile/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  Change_passwordLazyRoute: typeof Change_passwordLazyRoute
  Forgot_passwordLazyRoute: typeof Forgot_passwordLazyRoute
  hiddenFolderLayoutsRoute: typeof hiddenFolderLayoutsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/forgot_password': {
      id: '/forgot_password'
      path: '/forgot_password'
      fullPath: '/forgot_password'
      preLoaderRoute: typeof Forgot_passwordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change_password': {
      id: '/change_password'
      path: '/change_password'
      fullPath: '/change_password'
      preLoaderRoute: typeof Change_passwordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(hidden-folder)/_layouts': {
      id: '/(hidden-folder)/_layouts'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof hiddenFolderLayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRouteImport
      parentRoute: typeof hiddenFolderLayoutsRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/users': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutUsersLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/tutorial_faq': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/tutorial_faq'
      path: '/tutorial_faq'
      fullPath: '/tutorial_faq'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/ticket': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/ticket'
      path: '/ticket'
      fullPath: '/ticket'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutTicketLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/stats': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutStatsLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/reviews': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/posts': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/posts'
      path: '/posts'
      fullPath: '/posts'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutPostsLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/pos': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/pos'
      path: '/pos'
      fullPath: '/pos'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutPosLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/instagram_connector': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/instagram_connector'
      path: '/instagram_connector'
      fullPath: '/instagram_connector'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/ig_connector': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/ig_connector'
      path: '/ig_connector'
      fullPath: '/ig_connector'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/groups': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/google_sync': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/google_sync'
      path: '/google_sync'
      fullPath: '/google_sync'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/google_connector': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/google_connector'
      path: '/google_connector'
      fullPath: '/google_connector'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/google-my-business': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/google-my-business'
      path: '/google-my-business'
      fullPath: '/google-my-business'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/google-callback': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/google-callback'
      path: '/google-callback'
      fullPath: '/google-callback'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/form_unification': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/form_unification'
      path: '/form_unification'
      fullPath: '/form_unification'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/form_subentro': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/form_subentro'
      path: '/form_subentro'
      fullPath: '/form_subentro'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/facebook_connector': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/facebook_connector'
      path: '/facebook_connector'
      fullPath: '/facebook_connector'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/adv_admin': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/adv_admin'
      path: '/adv_admin'
      fullPath: '/adv_admin'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/adv': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/adv'
      path: '/adv'
      fullPath: '/adv'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutAdvLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
    '/(hidden-folder)/_layouts/_sideDrawerLayout/client_profile/$id/': {
      id: '/(hidden-folder)/_layouts/_sideDrawerLayout/client_profile/$id/'
      path: '/client_profile/$id'
      fullPath: '/client_profile/$id'
      preLoaderRoute: typeof hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRouteImport
      parentRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRoute
    }
  }
}

interface hiddenFolderLayoutsSideDrawerLayoutRouteChildren {
  hiddenFolderLayoutsSideDrawerLayoutAdvLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutAdvLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutPosLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutPosLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutPostsLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutPostsLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutStatsLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutStatsLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutTicketLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutTicketLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutUsersLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutUsersLazyRoute
  hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRoute: typeof hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRoute
}

const hiddenFolderLayoutsSideDrawerLayoutRouteChildren: hiddenFolderLayoutsSideDrawerLayoutRouteChildren =
  {
    hiddenFolderLayoutsSideDrawerLayoutAdvLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutAdvLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutAdv_adminLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutFacebook_connectorLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutForm_subentroLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutForm_unificationLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutGoogleCallbackLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutGoogleMyBusinessLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutGoogle_connectorLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutGoogle_syncLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutGroupsLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutIg_connectorLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutInstagram_connectorLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutPosLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutPosLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutPostsLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutPostsLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutReviewsLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutStatsLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutStatsLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutTicketLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutTicketLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutTutorial_faqLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutUsersLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutUsersLazyRoute,
    hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRoute:
      hiddenFolderLayoutsSideDrawerLayoutClient_profileIdIndexLazyRoute,
  }

const hiddenFolderLayoutsSideDrawerLayoutRouteWithChildren =
  hiddenFolderLayoutsSideDrawerLayoutRoute._addFileChildren(
    hiddenFolderLayoutsSideDrawerLayoutRouteChildren,
  )

interface hiddenFolderLayoutsRouteChildren {
  hiddenFolderLayoutsSideDrawerLayoutRoute: typeof hiddenFolderLayoutsSideDrawerLayoutRouteWithChildren
}

const hiddenFolderLayoutsRouteChildren: hiddenFolderLayoutsRouteChildren = {
  hiddenFolderLayoutsSideDrawerLayoutRoute:
    hiddenFolderLayoutsSideDrawerLayoutRouteWithChildren,
}

const hiddenFolderLayoutsRouteWithChildren =
  hiddenFolderLayoutsRoute._addFileChildren(hiddenFolderLayoutsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  Change_passwordLazyRoute: Change_passwordLazyRoute,
  Forgot_passwordLazyRoute: Forgot_passwordLazyRoute,
  hiddenFolderLayoutsRoute: hiddenFolderLayoutsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
